<template>
  <div class="pay">
    <div class="navbar_style" :class="$store.state.user.isNested && 'navbar_style_nested'">
      <Icon
        class="navbar_icon"
        name="arrow-left"
        @click="
          $router.push({ path: '/detail', query: { busiId: payInfo.busiId } })
        "
      />
      <span>{{ l.bank_pay_immediately }}</span>
      <div class="icon_box"></div>
    </div>
    <div class="pay_box" :class="$store.state.user.isNested && 'pay_box_nested'">
      <div class="repayment_title">
        uuPay
      </div>
      <div class="pay_tab">
        <div
          class="pay_tabs"
          v-if="Object.keys(pageData).length"
          @click="curIndex = 0"
          :class="curIndex == 0 && 'pay_tabsactive'"
        >
          Thanh toán trực tuyến
        </div>
        <div
          v-if="Object.keys(pageData2).length"
          class="pay_tabs"
          @click="curIndex = 1"
          :class="curIndex == 1 && 'pay_tabsactive'"
        >
          Thanh toán ngoại tuyến
        </div>
      </div>
      <div v-if="Object.keys(pageData).length && curIndex == 0">
        <div class="pay_container">
          <div class="item" v-if="pageData.bank_name">
            <div class="title">Ngân hàng</div>
            <div class="content">
              <div class="value">{{ pageData.bank_name }}</div>
            </div>
          </div>
          <div class="item" v-if="pageData.branch_bank_name">
            <div class="title">Chi nhánh</div>
            <div class="content">
              <div class="value">{{ pageData.branch_bank_name }}</div>
              <img
                class="copyBtn"
                @click="onCopy(pageData.branch_bank_name)"
                src="@/assets/uuPay/copy.png"
                alt=""
              />
            </div>
          </div>
          <div class="item" v-if="pageData.account_name">
            <div class="title">Tên tài khoản</div>
            <div class="content">
              <div class="value">{{ pageData.account_name }}</div>
              <img
                class="copyBtn"
                @click="onCopy(pageData.account_name)"
                src="@/assets/uuPay/copy.png"
                alt=""
              />
            </div>
          </div>
          <div class="item" v-if="pageData.va">
            <div class="title">Số tài khoản</div>
            <div class="content">
              <div class="value">{{ pageData.va }}</div>
              <img
                class="copyBtn"
                @click="onCopy(pageData.va)"
                src="@/assets/uuPay/copy.png"
                alt=""
              />
            </div>
          </div>
          <div class="item" v-if="pageData.amount">
            <div class="title">Số tiền cần trả</div>
            <div class="content">
              <div class="value">
                {{ pageData.amount ? formatMoney(pageData.amount) : 0 }}
              </div>
            </div>
          </div>
        </div>
        <!-- <img
          class="qrURL"
          v-if="pageData.guide_url"
          :src="pageData.guide_url"
          alt=""
        /> -->
        <div class="message">
          *Hướng dẫn trả tiền<br />
          1. Bạn có thể chọn chuyển khoản, đến ngân hàng, cửa hàng Viettel... để
          thực hiện thao tác thanh toán tiền.<br />
          2. Vui lòng đảm bảo nhập đầy đủ tài khoản ngân hàng khi thực hiện thao
          tác trả nợ. Nếu có các chữ cái trong tài khoản, hãy đảm bảo nhập đầy
          đủ các chữ cái đó cũng là một phần của tài khoản. Việc nhập tài khoản
          không đầy đủ sẽ khiến ngân hàng mất tiền của bạn hoặc bị ngân hàng từ
          chối.<br />
          3. Do hệ thống ngân hàng, 'chuyển khoản thông thường' không đảm bảo
          rằng tiền sẽ đến tài khoản của chúng tôi đúng lúc. Chúng tôi chỉ có
          thể đánh giá số tiền gửi thực tế của bạn và xóa số tiền đó dựa trên
          thời gian thực gửi tiền vào ngân hàng.<br />
        </div>
      </div>
      <div v-if="Object.keys(pageData2).length && curIndex == 1">
        <div class="pay_container">
          <div class="item" v-if="pageData2.bank_name">
            <!-- 银行 -->
            <div class="title">Ngân hàng</div>
            <div class="content">
              <div class="value">{{ pageData2.bank_name }}</div>
            </div>
          </div>
          <div class="item" v-if="pageData2.branch_bank_name">
            <!-- 支行 -->
            <div class="title">Chi nhánh</div>
            <div class="content">
              <div class="value">{{ pageData2.branch_bank_name }}</div>
              <img
                class="copyBtn"
                @click="onCopy(pageData.branch_bank_name)"
                src="@/assets/uuPay/copy.png"
                alt=""
              />
            </div>
          </div>
          <div class="item" v-if="pageData2.account_name">
            <!-- 账户名称 -->
            <div class="title">Tên tài khoản</div>
            <div class="content">
              <div class="value">{{ pageData2.account_name }}</div>
              <img
                class="copyBtn"
                @click="onCopy(pageData.account_name)"
                src="@/assets/uuPay/copy.png"
                alt=""
              />
            </div>
          </div>
          <div class="item" v-if="pageData2.va">
            <!-- 账户 -->
            <div class="title">Số tài khoản</div>
            <div class="content">
              <div class="value">{{ pageData2.va }}</div>
              <img
                class="copyBtn"
                @click="onCopy(pageData.va)"
                src="@/assets/uuPay/copy.png"
                alt=""
              />
            </div>
          </div>
          <div class="item" v-if="pageData2.amount">
            <!-- 还款金额 -->
            <div class="title">Số tiền cần trả</div>
            <div class="content">
              <div class="value">
                {{ pageData2.amount ? formatMoney(pageData2.amount) : 0 }}
              </div>
            </div>
          </div>
          <!-- 备注内容 -->
          <div class="item" v-if="pageData2.remarks">
            <div class="title">Nội dung ghi chú</div>
            <div class="content">
              <div class="value">{{ pageData2.remarks }}</div>
              <img
                class="copyBtn"
                @click="onCopy(pageData.remarks)"
                src="@/assets/uuPay/copy.png"
                alt=""
              />
            </div>
          </div>
          <div class="tips">
            * Trong lúc chuyển khoản vui lòng sao chép họ tên và số điện thoại
            xin vay của bạn, dùng ghi chú chuyển khoản.
          </div>
        </div>
        <div class="message">
          *Hướng dẫn trả tiền<br />
          1. Bạn có thể chọn chuyển khoản, đến ngân hàng, cửa hàng Viettel... để
          thực hiện thao tác thanh toán tiền<br />
          2. Vui lòng đảm bảo nhập đầy đủ tài khoản ngân hàng khi thực hiện thao
          tác trả nợ. Nếu có các chữ cái trong tài khoản, hãy đảm bảo nhập đầy
          đủ các chữ cái đó cũng là một phần của tài khoản. Việc nhập tài khoản
          không đầy đủ sẽ khiến ngân hàng mất tiền của bạn hoặc bị ngân hàng từ
          chối.<br />
          3. Do hệ thống ngân hàng, 'chuyển khoản thông thường' không đảm bảo
          rằng tiền sẽ đến tài khoản của chúng tôi đúng lúc. Chúng tôi chỉ có
          thể đánh giá số tiền gửi thực tế của bạn và xóa số tiền đó dựa trên
          thời gian thực gửi tiền vào ngân hàng.<br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Icon, Toast } from "vant";
import { formatMoney } from "@/utils";
import { getva } from "@/services/order";
import l from "@/locales";
export default {
  name: "pay",
  data() {
    return {
      copymessage: "Đã sao chép đến phần cắt",
      pageData: {},
      pageData2: {},
      order: undefined,
      curIndex: 0,
      l: l.repayMethods,
      payInfo: {},
    };
  },
  components: { Icon },
  methods: {
    formatMoney,
    copyonCopy() {
      Toast("Sao chép thành công");
    },
    copynError() {
      Toast("Sao chép thành công");
    },

    onCopy(str) {
      let url = str;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand("Copy"); // 执行浏览器复制命令
      Toast("Sao chép thành công!");
      oInput.remove();
    },
    getAmount() {
      let order = this.order;
      order.loan_status += "";
      let amount;
      switch (order.loan_status) {
        case "1":
        case "2":
        case "3":
        case "5":
          amount = order.amount2Account;
          break;
        case "4":
        case "6":
          amount = order.remainAmount;
          break;
        case "9":
          amount = order.reach_amount;
          break;
      }
      // if(amount.includes(",")){
      //     amount = amount.replaceAll(",","");
      // }
      // amount = 20000000;
      return amount;
    },
    async init(data) {
      this.order = data;
      // data.repaymentMethods = ["online", "offline"];
      // data.repaymentMethods = ["offline"];
      this.$nextTick(() => {
        data.repaymentMethods.forEach((v, k) => {
          if (v == "online") {
            if (k == 0) {
              this.curIndex = 0;
            }
            this.getOnline(data);
          } else if (v == "offline") {
            if (k == 0) {
              this.curIndex = 1;
            }
            this.getOffline(data);
          }
        });
      });
    },
    async getOnline(data) {
      const params = {
        amount: this.getAmount(),
        bank_code: this.order.bank_code,
        atm_otc: 1,
        vaType: 1,
        application_id: this.order.application_id,
        repayChannel: "uuPay",
      };
      let res = await getva({
        ...data,
        ...params,
      });
      console.log("resss", res);
      if (res.code == 200) {
        this.pageData = res.result;
      }
    },
    async getOffline(data) {
      const params = {
        amount: this.getAmount(),
        bank_code: this.order.bank_code,
        atm_otc: 3,
        vaType: 1,
        application_id: this.order.application_id,
        repayChannel: "uuPay",
      };
      let res = await getva({
        ...data,
        ...params,
      });
      if (res.code == 200) {
        this.pageData2 = res.result;
      }
    },
  },
  created() {
    this.init(JSON.parse(localStorage.getItem("androidData") || "{}"));
    this.payInfo = JSON.parse(localStorage.getItem("payInfo") || "{}");
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.pay {
  position: relative;
  height: 100%;
  min-height: 100vh;
  background-color: #ffffff;

  .pay_box {
    position: absolute;
    top: 30px;
    left: 0;
    box-sizing: border-box;
    width: 100%;
    padding: 0 20px;
    padding-top: 30px;
    &_nested{
      top: 70px;
    }
    .repayment_title {
      font-size: 22px;
      font-weight: bold;
      margin-left: 5px;
      text-align: center;
    }
    .pay_tab {
      margin-top: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .pay_tabs {
      width: 160px;
      height: 40px;
      background: #ffffff;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.05);
      border-radius: 13px;

      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #9d9fa8;

      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
    }
    .pay_tabs:nth-child(2) {
      margin-left: 15px;
    }
    .pay_tabsactive {
      position: relative;
      font-weight: 500;
      color: #45A1FF;

      &::before {
        position: absolute;
        content: "";
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 50px;
        height: 4px;
        background: #F8FBFF;
        border-radius: 100px 100px 0px 0px;
        opacity: 0.4;
      }
    }
  }
}
.pay_container {
  width: 100%;
  margin-top: 20px;
  box-sizing: border-box;

  .item {
    margin-bottom: 10px;
    .title {
      // flex: 1;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #6c6d6f;
      &::after {
        content: ":";
        margin-left: 4px;
      }
    }
    .content {
      margin-top: 5px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;

      height: 42px;
      background: rgba(69,161,255,0.1);
      border-radius: 21px;
      border: 1px solid #45A1FF;

      .value {
        flex: 1;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #324353;
      }
      .copyBtn {
        width: 20px;
        height: 20px;
      }
    }
  }
}
.tips {
  margin-top: 10px;

  font-size: 11px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ff3a1a;
  line-height: 16px;
}
.qrURL {
  margin-top: 10px;
  width: 100%;
}
.message {
  margin-top: 20px;
  margin-bottom: 20px;
  padding-top: 20px;
  box-sizing: border-box;
  letter-spacing: 0;

  border-top: 1px dashed transparent;
  background: linear-gradient(#ffffff, #ffffff) padding-box,
    repeating-linear-gradient(
      -45deg,
      #45A1FF 0,
      #45A1FF 6px,
      #ffffff 0,
      #ffffff 10px
    );

  font-size: 11px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #979797;
  line-height: 16px;
}
</style>
